import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

export const PostItem = props => {
  const { title, text, image, link, postType, author, authorImage } = props;
  const toLink = `/blog${link}`;
  if (postType === "thumbnail") {
    return (
      <Col className="news-style-one" md={4} sm={6} xs={12}>
        <div className="inner-box wow fadeInUp" {...props}>
          <figure className="image-box">
            <Link to={toLink}>
              <img
                src={require("../../../assets/images/posts")[image]}
                alt={title}
              />
            </Link>
          </figure>
          <div className="lower-box">
            <div className="post-author">
              <img
                src={require("../../../assets/images/team")[authorImage]}
                alt={author}
              />
              <span>{author}</span>
            </div>
            <h3>
              <Link to={toLink}>{title}</Link>
            </h3>
            <div className="text-center">
              <Link to={toLink} className="theme-btn btn-style-ten">
                More Details
              </Link>
            </div>
          </div>
        </div>
      </Col>
    );
  }

  if (postType === "singlePost") {
    return (
      <div className="news-style-two">
        <div className="inner-box">
          <figure className="image-box">
            <img
              src={require("../../../assets/images/posts")[image]}
              alt={title}
            />
          </figure>
          <div className="lower-box">
            <div className="post-author">
              <img
                src={require("../../../assets/images/team")[authorImage]}
                alt={author}
              />
              <span>{author}</span>
            </div>
            <h3>{title}</h3>
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: `${text}` }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-style-two">
      <div className="inner-box">
        <figure className="image-box">
          <Link to={toLink}>
            <img
              src={require("../../../assets/images/posts")[image]}
              alt={title}
            />
          </Link>
        </figure>
        <div className="lower-box">
          <div className="post-author">
            <img
              src={require("../../../assets/images/team")[authorImage]}
              alt={author}
            />
            <span>{author}</span>
          </div>
          <h3>
            <Link to={toLink}>{title}</Link>
          </h3>
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: `${text}` }}
          />
          <div className="more-btn">
            <Link to={toLink} className="theme-btn">
              More Details <span className="fa fa-long-arrow-right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ui/Blog/PostItem.js